import { render, staticRenderFns } from "./ModalCadastroFiliacao.vue?vue&type=template&id=4445afcf"
import script from "./ModalCadastroFiliacao.vue?vue&type=script&lang=js"
export * from "./ModalCadastroFiliacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports